export default "<span class=\"listing__primary truncate\" data-attr=\"{ 'title': title }\">\n    <span>{{ title }}</span>\n</span>\n"